import SegmentImageDetailModel from './SegmentImageDetailModel'

export default {
  name : 'Segment Images',
  displayName : 'Segment Images',
  objectType : 'segment',
  attrName : 'segment.images',
  create : () => {
    return SegmentImageDetailModel.create( 'segment.images', 'segment' )
  }
}
